import React from 'react'
import styles from './styles.scss'
import CSSModules from 'helpers/CSSModulesUtil'
import Dropdown from 'components/fulcrum/dropdown/FulcrumDropdown'
import Subheading from 'components/typography/subheading/index'

const ReportHeader2 = (props) => {
    return (
        <div styleName='header'>
            <Subheading theme={styles}>{props.title}</Subheading>
            {props.showDropdown && <Dropdown className={styles.dropdown} value={props.value} source={props.source} onChange={props.onChange}/>}
        </div>

    )
}

export default CSSModules(styles)(ReportHeader2)
